import { DataRoomDashboardStats } from 'models/DealRoom';
import httpClient from '../../httpClient';

function getDashStats(dataRoomId: string) {
  return httpClient.get<DataRoomDashboardStats>(
    `data-rooms/${dataRoomId}/dashboard-stats`,
  );
}

export default { getDashStats };
